import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import { useRegistrarAcordoSiengeContext } from "..";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStepForward } from "@fortawesome/free-solid-svg-icons";
import Table from "../../../../../Components/Table";
import { useEffect, useState } from "react";
import { IParcelaBoletos } from "../../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";

export default function SelecaoParcelas() {
    const {
        goToStep,
        lstSelecionados,
        setLstSelecionados,
        parcelaReq,
        setParcelaReq,
        lstTodasParcelas,
    } = useRegistrarAcordoSiengeContext();

    const [lstParcelas, setlstParcelas] = useState<Array<IParcelaBoletos>>();
    const [enableNextStep, setEnableNextStep] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        lstTodasParcelas
            .get()
            .then((res) => {
                setlstParcelas(res);

                setEnableNextStep((lstSelecionados?.length || 0) > 0);
            })
            .finally(() => setLoading(false));
    }, [lstSelecionados, lstTodasParcelas]);

    const columns: Array<ColumnDescription> = [
        {
            dataField: "Tipo_Prc",
            text: "Parcela",
            classes: "p-3 ws-nowrap align-middle text-center",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {`${c ? c : ""} - ${row.Descricao_par} - ${
                            row.NumParc_Prc
                        }`}
                    </span>
                );
            },
            headerAlign: "center",
        },
        {
            dataField: "Data_Prc",
            text: "Data de Vencimento",
            formatter: (c) => {
                const data = new Date(c);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {new Date(c).toLocaleDateString()}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "ValorReaj",
            text: "Valor Reajus.",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "Valor_Prc",
            text: "Valor Principal",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "ValorMulta",
            text: "Multa",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "vlrJurosAtraso",
            text: "Juros",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
    ];

    const selectRowProp: SelectRowProps<any> = {
        mode: "checkbox",
        clickToSelect: true,
        selected: lstSelecionados?.map((p) => p.NumParc_Prc),

        onSelect: (row, isSelect, rowIndex, e) => {
            setLstSelecionados((prevSelecionados) => {
                if (isSelect) {
                    return [...(prevSelecionados ?? []), row];
                } else {
                    return (
                        prevSelecionados?.filter(
                            (selec) => selec.NumParc_Prc !== row.NumParc_Prc
                        ) || []
                    );
                }
            });
        },

        onSelectAll: (isSelect, rows) => {
            setLstSelecionados((prevSelecionados) => {
                if (isSelect) {
                    return [...(prevSelecionados ?? []), ...rows];
                } else {
                    return (
                        prevSelecionados?.filter(
                            (selec) =>
                                !rows.some(
                                    (row) =>
                                        row.NumParc_Prc === selec.NumParc_Prc
                                )
                        ) || []
                    );
                }
            });
        },
    };

    return (
        <div className="mt-5">
            <h3>Selecione as parcelas para a renegociação:</h3>
            <div className="row">
                <div className="col-12 col-sm-6">
                    <label className="text-muted mb-0">
                        Data de reparcelamento
                    </label>
                    <input
                        type="date"
                        className={`form-control px-0 p-2`}
                        defaultValue={parcelaReq.DT_CALCULO}
                        onBlur={(e) => {
                            const DT_CALCULO = e.target.value;
                            if (
                                DT_CALCULO &&
                                DT_CALCULO !== parcelaReq.DT_CALCULO
                            ) {
                                setParcelaReq({
                                    DT_CALCULO,
                                });
                            }
                        }}
                    />
                </div>
                <div className="col-12 col-sm-6">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <h4>Valor Total Parcelas:</h4>
                        <span className="font-size-lg text-muted font-weight-bold">
                            {formatMoneyReais(
                                lstSelecionados?.reduce(
                                    (sum, parcela) => sum + parcela.ValorReaj,
                                    0.0
                                ) ?? 0
                            )}
                        </span>
                    </div>
                </div>
            </div>
            <div className="mt-8">
                <Table
                    data={lstParcelas ?? []}
                    columns={columns}
                    keyField="NumParc_Prc"
                    bordered={false}
                    rowClasses="border-bottom border-gray checkbox-table"
                    sizePerPage={lstParcelas?.length}
                    selectRow={selectRowProp}
                    loading={loading}
                    wrapperClasses="y-scroll maxHeight-300 mb-2"
                    noPagination
                    noSearch
                    striped
                />
            </div>
            <div className="d-flex justify-content-end mt-5">
                <button
                    disabled={lstSelecionados?.length === 0 || !enableNextStep}
                    className="btn btn-primary"
                    onClick={() => {
                        goToStep("condicoesPagamento");
                    }}
                >
                    Selecionar Parcelas
                    <FontAwesomeIcon className="ml-2" icon={faStepForward} />
                </button>
            </div>
        </div>
    );
}
